"use strict";
// The Kit Tool Label presets offered in Manage Kits. These were web's
// NODE_DEF_LABEL_DEFAULTS, whose ids were a per-load uuidv4(): fine for a
// render key, useless once labels are stored. Ids are now stable author-time
// strings so a stored label keeps its identity across sessions and surfaces.
Object.defineProperty(exports, "__esModule", { value: true });
exports.customKitToolLabelId = exports.KIT_TOOL_LABEL_PRESETS = exports.KIT_TOOL_LABEL_PRESET_KEYS = void 0;
const types_1 = require("./types");
exports.KIT_TOOL_LABEL_PRESET_KEYS = ['AUDIO', 'MODELS', 'POPULAR', 'START_END_FRAME'];
exports.KIT_TOOL_LABEL_PRESETS = {
    AUDIO: {
        id: 'label:audio',
        icon: 'mdi-volume-high',
        label: 'Audio',
        value: null,
        type: types_1.KIT_TOOL_LABEL_TYPE.HIGHLIGHT,
        tooltip: 'This tool generates audio',
    },
    MODELS: {
        id: 'label:models',
        icon: 'mdi-weight-lifter',
        label: 'Models',
        value: null,
        type: types_1.KIT_TOOL_LABEL_TYPE.HIGHLIGHT,
        tooltip: 'This tool lets you pick from your trained models',
    },
    POPULAR: {
        id: 'label:popular',
        icon: 'mdi-fire',
        label: 'Popular',
        value: null,
        type: types_1.KIT_TOOL_LABEL_TYPE.POPULAR,
        tooltip: 'This tool is popular with our users',
    },
    START_END_FRAME: {
        id: 'label:startEndFrame',
        icon: 'mdi-video-image',
        label: 'Start/End Frame',
        value: null,
        type: types_1.KIT_TOOL_LABEL_TYPE.HIGHLIGHT,
        tooltip: 'This tool supports start and end frame video generation',
    },
};
/**
 * A stable id for a label authored in Manage Kits that is not one of the
 * presets. Deterministic in the Kit Type + tool + label text, so re-running
 * the seed or re-saving an unchanged Kit does not churn ids.
 */
const customKitToolLabelId = (kitType, nodeDefId, label) => `label:${kitType}:${nodeDefId}:${label.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`;
exports.customKitToolLabelId = customKitToolLabelId;
